import { useEffect, useState } from 'react'
import './index.css'
import { FallingStars } from './FallingStars'
import { readBotLinkFromPage, type BotLinkState } from './botState'
import { LOCALE_STORAGE_KEY, readStoredLocale, t, type Locale } from './i18n'

export function App() {
	const [locale, setLocale] = useState<Locale>(readStoredLocale)
	const [backgroundUrl, setBackgroundUrl] = useState<string | null>(null)
	const [botLink] = useState<BotLinkState>(readBotLinkFromPage)
	const copy = t(locale)

	useEffect(() => {
		try {
			localStorage.setItem(LOCALE_STORAGE_KEY, locale)
		} catch (error) {
			console.error('Failed to save locale to localStorage:', error)
		}
	}, [locale])

	useEffect(() => {
		fetch('/api/backgrounds')
			.then(res => res.json())
			.then((files: string[]) => {
				if (files.length === 0) return
				const file = files[Math.floor(Math.random() * files.length)]!
				setBackgroundUrl(`/background/${encodeURIComponent(file)}`)
			})
			.catch(error => {
				console.error('Failed to fetch backgrounds:', error)
			})
	}, [])

	return (
		<div
			className='landing'
			style={
				backgroundUrl ? { backgroundImage: `url(${backgroundUrl})` } : undefined
			}
		>
			<FallingStars />
			<div className='landing__overlay' />
			<main className='landing__panel landing__panel--info'>
				<h1 className='landing__title'>Prime Shop</h1>
				<div className='landing__cta'>
					{botLink.ok ? (
						<a
							className='landing__button'
							lang={locale}
							href={botLink.url}
							target='_blank'
							rel='noopener noreferrer'
						>
							{copy.button}
						</a>
					) : (
						<button
							type='button'
							className='landing__button landing__button--disabled'
							disabled
							lang={locale}
							aria-disabled='true'
						>
							{copy.button}
						</button>
					)}
					{!botLink.ok ? (
						<p className='landing__unavailable' lang={locale}>
							{copy.botsUnavailable}
						</p>
					) : null}
				</div>
			</main>
			<aside className='landing__panel landing__panel--warning' role='note'>
				<span className='landing__warn-icon' aria-hidden='true' />
				<p className='landing__notice' lang={locale}>
					{copy.notice}
				</p>
			</aside>
		</div>
	)
}
